// extracted by mini-css-extract-plugin
export var label = "_fg-2";
export var slideContainer = "_fg-0";
export var slider = "_fg-1";